import React from "react";
import { ConditionPreset, ConditionPresetMeta } from "../../../../../../models/Entities";
import { TextFieldVariant, Typeahead } from "@merge-api/merge-javascript-shared";
import { getFilteredModelOptions } from "../helpers";
import startCase from "lodash/startCase";
import UpsellFilterOptionMessage from "./UpsellFilterOptionMessage";

type CommonModelSelectProps = {
  conditionPreset: Partial<ConditionPreset>;
  conditionPresetMeta: ConditionPresetMeta;
  conditionPresets: Partial<ConditionPreset>[];
  onConditionPresetChange: (ConditionPreset: Partial<ConditionPreset>) => void;
  showGatedSelectiveSync: boolean;
  disabled?: boolean;
};

const CommonModelSelect = ({
  conditionPreset,
  conditionPresetMeta,
  conditionPresets,
  onConditionPresetChange,
  showGatedSelectiveSync,
  disabled,
}: CommonModelSelectProps) => {
  // derived state
  const commonModelOptions: string[] = getFilteredModelOptions(
    conditionPreset,
    conditionPresetMeta,
    conditionPresets,
  );

  // event handlers
  const onCommonModelChange = (_: any, commonModel: string | null) => {
    onConditionPresetChange({
      ...conditionPreset,
      common_model: commonModel || undefined,

      // reset other fields
      normalized_key_name: undefined,
      operator: undefined,
      value: undefined,
      is_end_user_configured: false,
    });
  };

  return (
    <div className="flex flex-1">
      {showGatedSelectiveSync ? (
        <Typeahead
          className="h-full py-[3px]"
          borderVariant={TextFieldVariant.InlinedRounded}
          options={conditionPreset.common_model ? [conditionPreset.common_model] : []}
          disableClearable
          value={conditionPreset.common_model}
          typeaheadFooter={<UpsellFilterOptionMessage />}
          disabled={disabled}
        />
      ) : (
        <Typeahead
          className="h-full py-[3px]"
          placeholder="Select Common Model..."
          noOptionsText="No filters available"
          borderVariant={TextFieldVariant.InlinedRounded}
          options={commonModelOptions}
          getOptionLabel={(option) => startCase(option)}
          disableClearable
          value={conditionPreset.common_model}
          onChange={onCommonModelChange}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default CommonModelSelect;
